import { render, staticRenderFns } from "./GreetingLabel.vue?vue&type=template&id=760c27a8&scoped=true"
import script from "./GreetingLabel.vue?vue&type=script&lang=js"
export * from "./GreetingLabel.vue?vue&type=script&lang=js"
import style0 from "./GreetingLabel.vue?vue&type=style&index=0&id=760c27a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c27a8",
  null
  
)

export default component.exports